const Config = {
  PORT : '3000',
  SERVER : localStorage.getItem('SERVER'),
}

export default Config
